(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5363],{

/***/ 15363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Parallax; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-snowfall/lib/Snowfall.js
var Snowfall = __webpack_require__(71106);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
;// CONCATENATED MODULE: ./styles/jss/bbhost/components/parallaxStyle.js

var parallaxStyle = function(theme) {
    return {
        parallax: {
            height: "60vh",
            maxHeight: "1000px",
            overflow: "hidden",
            position: "relative",
            backgroundPosition: "center top",
            backgroundSize: "cover",
            margin: "0",
            padding: "0",
            border: "0",
            display: "flex",
            alignItems: "center"
        },
        filter: {
            "&:before": {
                background: "rgba(0, 0, 0, 0.5)"
            },
            "&:after,&:before": {
                position: "absolute",
                zIndex: "1",
                width: "100%",
                height: "100%",
                display: "block",
                left: "0",
                top: "0",
                content: "''"
            }
        },
        small: {
            height: "450px"
        },
        parallaxResponsive: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            minHeight: "550px"
        })
    };
};
/* harmony default export */ var components_parallaxStyle = (parallaxStyle);

// EXTERNAL MODULE: ./configs/index.js + 16 modules
var configs = __webpack_require__(91856);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
;// CONCATENATED MODULE: ./components/Parallax/Parallax.js









// @material-ui/core components

// core components



var datasComemorativas = {
    datas: [
        {
            name: "hallowen",
            initDate: "10-28",
            finishDate: "10-31"
        },
        {
            name: "pre_natal",
            initDate: "11-20",
            finishDate: "12-09",
            effect: /*#__PURE__*/ (0,jsx_runtime.jsx)(Snowfall/* default */.Z, {
                style: {
                    zIndex: "10000",
                    position: "fixed"
                },
                speed: [
                    0.5,
                    3
                ],
                snowflakeCount: "75"
            })
        },
        {
            name: "natal",
            initDate: "12-10",
            finishDate: "12-31",
            effect: /*#__PURE__*/ (0,jsx_runtime.jsx)(Snowfall/* default */.Z, {
                style: {
                    zIndex: "10000",
                    position: "fixed"
                },
                speed: [
                    0.5,
                    3
                ],
                snowflakeCount: "75"
            })
        },
        {
            name: "ano_novo",
            initDate: "01-01",
            finishDate: "01-05"
        }, 
    ],
    isDataComemorativa: function isDataComemorativa() {
        var date = new Date();
        var isDataComemorativa1 = false;
        this.getDatasComemorativas().forEach(function(value) {
            if (date.getTime() >= value.initDate && date.getTime() <= value.finishDate) {
                isDataComemorativa1 = true;
                return;
            }
        });
        return isDataComemorativa1;
    },
    getDatasComemorativas: function getDatasComemorativas() {
        var year = new Date().getFullYear();
        return this.datas.map(function(value) {
            return {
                initDate: new Date("".concat(year, "-").concat(value.initDate, " 00:00:00 -3")).getTime(),
                finishDate: new Date("".concat(year, "-").concat(value.finishDate, " 23:59:59 -3")).getTime(),
                name: value.name,
                effect: value.effect !== undefined ? value.effect : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
            };
        });
    },
    getBG: function getBG(default_name) {
        var date = new Date();
        var name = default_name;
        this.getDatasComemorativas().forEach(function(value) {
            if (date.getTime() >= value.initDate && date.getTime() <= value.finishDate) {
                name = value.name;
                return;
            }
        });
        return name;
    },
    getEffect: function getEffect() {
        var date = new Date();
        var effect = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        this.getDatasComemorativas().forEach(function(value) {
            if (date.getTime() >= value.initDate && date.getTime() <= value.finishDate) {
                effect = value.effect;
                return;
            }
        });
        return effect;
    }
};
var useStyles = (0,makeStyles/* default */.Z)(components_parallaxStyle);
function Parallax(props) {
    var ref = (0,react.useState)("translate3d(0,0px,0)"), transform = ref[0], setTransform = ref[1];
    var ref1 = (0,react.useState)(""), showEffectComemorativo = ref1[0], setShowEffectComemorativo = ref1[1];
    var ref2 = (0,react.useState)((0,configs/* getBGPath */.E1)("default")), BGViewState = ref2[0], setBGViewState = ref2[1];
    (0,react.useEffect)(function() {
        var bgName = datasComemorativas.getBG(props.name);
        var image = /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        if (lib/* isMobile */.tq) {
            image = (0,configs/* getBGPath */.E1)(bgName, true);
            setBGViewState(image);
        } else {
            image = (0,configs/* getBGPath */.E1)(bgName);
            setBGViewState(image);
        }
        setShowEffectComemorativo(datasComemorativas.getEffect());
    }, [
        props
    ]);
    var filter = props.filter, className = props.className, children = props.children, style = props.style, small = props.small, responsive = props.responsive, blocked = props.blocked;
    (0,react.useEffect)(function() {
        if (window.innerWidth >= 768) {
            window.addEventListener("scroll", resetTransform);
        }
        return function cleanup() {
            if (window.innerWidth >= 768) {
                window.removeEventListener("scroll", resetTransform);
            }
        };
    });
    var resetTransform = function() {
        var windowScrollTop = window.pageYOffset / 3;
        setTransform("translate3d(0," + windowScrollTop + "px,0)");
    };
    var classes = useStyles();
    var _obj;
    var parallaxClasses = classnames_default()((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.parallax, true), (0,_define_property/* default */.Z)(_obj, classes.filter, filter), (0,_define_property/* default */.Z)(_obj, classes.small, small), (0,_define_property/* default */.Z)(_obj, classes.parallaxResponsive, responsive), (0,_define_property/* default */.Z)(_obj, className, className !== undefined), _obj));
    if (blocked) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: parallaxClasses,
            style: {
                height: "300px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: BGViewState,
                        layout: "fill",
                        alt: "BB Host, datacenter de qualidade!",
                        priority: "false",
                        objectFit: "cover",
                        quality: 100,
                        objectPosition: "right"
                    })
                }),
                children
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showEffectComemorativo,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: parallaxClasses,
                style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
                    transform: transform
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: BGViewState,
                            layout: "fill",
                            alt: "BB Host, datacenter de qualidade!",
                            priority: "false",
                            objectFit: "cover",
                            quality: 100,
                            objectPosition: "right"
                        })
                    }),
                    children
                ]
            })
        ]
    });
}
Parallax.propTypes = {
    className: (prop_types_default()).string,
    filter: (prop_types_default()).bool,
    children: (prop_types_default()).node,
    style: (prop_types_default()).string,
    name: (prop_types_default()).string,
    small: (prop_types_default()).bool,
    // this will add a min-height of 660px on small screens
    responsive: (prop_types_default()).bool
};


/***/ }),

/***/ 69590:
/***/ (function(module) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),

/***/ 71106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _config = __webpack_require__(12136);

var _hooks = __webpack_require__(16906);

var _Snowflake = __webpack_require__(10370);

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Snowfall = function Snowfall() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? _Snowflake.defaultConfig.color : _ref$color,
      _ref$changeFrequency = _ref.changeFrequency,
      changeFrequency = _ref$changeFrequency === void 0 ? _Snowflake.defaultConfig.changeFrequency : _ref$changeFrequency,
      _ref$radius = _ref.radius,
      radius = _ref$radius === void 0 ? _Snowflake.defaultConfig.radius : _ref$radius,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? _Snowflake.defaultConfig.speed : _ref$speed,
      _ref$wind = _ref.wind,
      wind = _ref$wind === void 0 ? _Snowflake.defaultConfig.wind : _ref$wind,
      _ref$rotationSpeed = _ref.rotationSpeed,
      rotationSpeed = _ref$rotationSpeed === void 0 ? _Snowflake.defaultConfig.rotationSpeed : _ref$rotationSpeed,
      _ref$snowflakeCount = _ref.snowflakeCount,
      snowflakeCount = _ref$snowflakeCount === void 0 ? 150 : _ref$snowflakeCount,
      images = _ref.images,
      style = _ref.style;

  var mergedStyle = (0, _hooks.useSnowfallStyle)(style);
  var canvasRef = (0, _react.useRef)(null);
  var canvasSize = (0, _hooks.useComponentSize)(canvasRef);
  var animationFrame = (0, _react.useRef)(0);
  var lastUpdate = (0, _react.useRef)(Date.now());
  var config = (0, _hooks.useDeepMemo)({
    color: color,
    changeFrequency: changeFrequency,
    radius: radius,
    speed: speed,
    wind: wind,
    rotationSpeed: rotationSpeed,
    images: images
  });
  var snowflakes = (0, _hooks.useSnowflakes)(canvasRef, snowflakeCount, config);
  var render = (0, _react.useCallback)(function () {
    var framesPassed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var canvas = canvasRef.current;

    if (canvas) {
      // Update the positions of the snowflakes
      snowflakes.forEach(function (snowflake) {
        return snowflake.update(canvas, framesPassed);
      }); // Render them if the canvas is available

      var ctx = canvas.getContext('2d');

      if (ctx) {
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
        snowflakes.forEach(function (snowflake) {
          return snowflake.draw(ctx);
        });
      }
    }
  }, [snowflakes]);
  var loop = (0, _react.useCallback)(function () {
    // Update based on time passed so that a slow frame rate won't slow down the snowflake
    var now = Date.now();
    var msPassed = Date.now() - lastUpdate.current;
    lastUpdate.current = now; // Frames that would have passed if running at 60 fps

    var framesPassed = msPassed / _config.targetFrameTime;
    render(framesPassed);
    animationFrame.current = requestAnimationFrame(loop);
  }, [render]);
  (0, _react.useEffect)(function () {
    loop();
    return function () {
      return cancelAnimationFrame(animationFrame.current);
    };
  }, [loop]);
  return /*#__PURE__*/_react["default"].createElement("canvas", {
    ref: canvasRef,
    height: canvasSize.height,
    width: canvasSize.width,
    style: mergedStyle,
    "data-testid": "SnowfallCanvas"
  });
};

var _default = Snowfall;
exports.Z = _default;
//# sourceMappingURL=Snowfall.js.map

/***/ }),

/***/ 10370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultConfig = exports["default"] = void 0;

var _reactFastCompare = _interopRequireDefault(__webpack_require__(69590));

var _utils = __webpack_require__(57486);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultConfig = {
  color: '#dee4fd',
  radius: [0.5, 3.0],
  speed: [1.0, 3.0],
  wind: [-0.5, 2.0],
  changeFrequency: 200,
  rotationSpeed: [-1.0, 1.0]
};
exports.defaultConfig = defaultConfig;

/**
 * An individual snowflake that will update it's location every call to `update`
 * and draw itself to the canvas every call to `draw`.
 */
var Snowflake = /*#__PURE__*/function () {
  function Snowflake(canvas) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Snowflake);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "params", void 0);

    _defineProperty(this, "framesSinceLastUpdate", void 0);

    _defineProperty(this, "image", void 0);

    // Set custom config
    this.updateConfig(config); // Setting initial parameters

    var _this$config = this.config,
        radius = _this$config.radius,
        wind = _this$config.wind,
        speed = _this$config.speed,
        rotationSpeed = _this$config.rotationSpeed;
    this.params = {
      x: (0, _utils.random)(0, canvas.offsetWidth),
      y: (0, _utils.random)(-canvas.offsetHeight, 0),
      rotation: (0, _utils.random)(0, 360),
      radius: _utils.random.apply(void 0, _toConsumableArray(radius)),
      speed: _utils.random.apply(void 0, _toConsumableArray(speed)),
      wind: _utils.random.apply(void 0, _toConsumableArray(wind)),
      rotationSpeed: _utils.random.apply(void 0, _toConsumableArray(rotationSpeed)),
      nextSpeed: _utils.random.apply(void 0, _toConsumableArray(wind)),
      nextWind: _utils.random.apply(void 0, _toConsumableArray(speed)),
      nextRotationSpeed: _utils.random.apply(void 0, _toConsumableArray(rotationSpeed))
    };
    this.framesSinceLastUpdate = 0;
  }

  _createClass(Snowflake, [{
    key: "selectImage",
    value: function selectImage() {
      if (this.config.images && this.config.images.length > 0) {
        this.image = (0, _utils.randomElement)(this.config.images);
      } else {
        this.image = undefined;
      }
    }
  }, {
    key: "updateConfig",
    value: function updateConfig(config) {
      var previousConfig = this.config;
      this.config = _objectSpread(_objectSpread({}, defaultConfig), config);
      this.config.changeFrequency = (0, _utils.random)(this.config.changeFrequency, this.config.changeFrequency * 1.5); // Update the radius if the config has changed, it won't gradually update on it's own

      if (this.params && !(0, _reactFastCompare["default"])(this.config.radius, previousConfig === null || previousConfig === void 0 ? void 0 : previousConfig.radius)) {
        this.params.radius = _utils.random.apply(void 0, _toConsumableArray(this.config.radius));
      }

      if (!(0, _reactFastCompare["default"])(this.config.images, previousConfig === null || previousConfig === void 0 ? void 0 : previousConfig.images)) {
        this.selectImage();
      }
    }
  }, {
    key: "updateTargetParams",
    value: function updateTargetParams() {
      this.params.nextSpeed = _utils.random.apply(void 0, _toConsumableArray(this.config.speed));
      this.params.nextWind = _utils.random.apply(void 0, _toConsumableArray(this.config.wind));

      if (this.image) {
        this.params.nextRotationSpeed = _utils.random.apply(void 0, _toConsumableArray(this.config.rotationSpeed));
      }
    }
  }, {
    key: "update",
    value: function update(canvas) {
      var framesPassed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var _this$params = this.params,
          x = _this$params.x,
          y = _this$params.y,
          rotation = _this$params.rotation,
          rotationSpeed = _this$params.rotationSpeed,
          nextRotationSpeed = _this$params.nextRotationSpeed,
          wind = _this$params.wind,
          speed = _this$params.speed,
          nextWind = _this$params.nextWind,
          nextSpeed = _this$params.nextSpeed,
          radius = _this$params.radius; // Update current location, wrapping around if going off the canvas

      this.params.x = (x + wind * framesPassed) % (canvas.offsetWidth + radius * 2);
      if (this.params.x > canvas.offsetWidth + radius) this.params.x = -radius;
      this.params.y = (y + speed * framesPassed) % (canvas.offsetHeight + radius * 2);
      if (this.params.y > canvas.offsetHeight + radius) this.params.y = -radius; // Apply rotation

      if (this.image) {
        this.params.rotation = (rotation + rotationSpeed) % 360;
      } // Update the wind, speed and rotation towards the desired values


      this.params.speed = (0, _utils.lerp)(speed, nextSpeed, 0.01);
      this.params.wind = (0, _utils.lerp)(wind, nextWind, 0.01);
      this.params.rotationSpeed = (0, _utils.lerp)(rotationSpeed, nextRotationSpeed, 0.01);

      if (this.framesSinceLastUpdate++ > this.config.changeFrequency) {
        this.updateTargetParams();
        this.framesSinceLastUpdate = 0;
      }
    }
  }, {
    key: "getImageOffscreenCanvas",
    value: function getImageOffscreenCanvas(image, size) {
      var _sizes$size;

      if (image instanceof HTMLImageElement && image.loading) return image;
      var sizes = Snowflake.offscreenCanvases.get(image);

      if (!sizes) {
        sizes = {};
        Snowflake.offscreenCanvases.set(image, sizes);
      }

      if (!(size in sizes)) {
        var _canvas$getContext;

        var canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        (_canvas$getContext = canvas.getContext('2d')) === null || _canvas$getContext === void 0 ? void 0 : _canvas$getContext.drawImage(image, 0, 0, size, size);
        sizes[size] = canvas;
      }

      return (_sizes$size = sizes[size]) !== null && _sizes$size !== void 0 ? _sizes$size : image;
    }
  }, {
    key: "draw",
    value: function draw(ctx) {
      if (this.image) {
        // ctx.save()
        // ctx.translate(this.params.x, this.params.y)
        ctx.setTransform(1, 0, 0, 1, this.params.x, this.params.y);
        var radius = Math.ceil(this.params.radius);
        ctx.rotate(this.params.rotation * Math.PI / 180);
        ctx.drawImage(this.getImageOffscreenCanvas(this.image, radius), -Math.ceil(radius / 2), -Math.ceil(radius / 2), radius, radius); // ctx.restore()
      } else {
        ctx.beginPath();
        ctx.arc(this.params.x, this.params.y, this.params.radius, 0, 2 * Math.PI);
        ctx.fillStyle = this.config.color;
        ctx.closePath();
        ctx.fill();
      }
    }
  }]);

  return Snowflake;
}();

_defineProperty(Snowflake, "offscreenCanvases", new WeakMap());

var _default = Snowflake;
exports["default"] = _default;
//# sourceMappingURL=Snowflake.js.map

/***/ }),

/***/ 12136:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.targetFrameTime = exports.snowfallBaseStyle = void 0;
var snowfallBaseStyle = {
  pointerEvents: 'none',
  backgroundColor: 'transparent',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%'
}; // Target of 60 frames per second

exports.snowfallBaseStyle = snowfallBaseStyle;
var targetFrameTime = 1000 / 60;
exports.targetFrameTime = targetFrameTime;
//# sourceMappingURL=config.js.map

/***/ }),

/***/ 16906:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useComponentSize = void 0;
exports.useDeepCompareEffect = useDeepCompareEffect;
exports.useDeepMemo = useDeepMemo;
exports.useSnowflakes = exports.useSnowfallStyle = void 0;

var _react = __webpack_require__(67294);

var _reactFastCompare = _interopRequireDefault(__webpack_require__(69590));

var _Snowflake = _interopRequireDefault(__webpack_require__(10370));

var _config = __webpack_require__(12136);

var _utils = __webpack_require__(57486);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * A utility function to create a collection of snowflakes
 * @param canvasRef A ref to the canvas element
 * @param amount The number of snowflakes
 * @param config The configuration for each snowflake
 */
var createSnowflakes = function createSnowflakes(canvasRef, amount, config) {
  if (!canvasRef.current) return [];
  var snowflakes = [];

  for (var i = 0; i < amount; i++) {
    snowflakes.push(new _Snowflake["default"](canvasRef.current, config));
  }

  return snowflakes;
};
/**
 * A utility hook to manage creating and updating a collection of snowflakes
 * @param canvasRef A ref to the canvas element
 * @param amount The number of snowflakes
 * @param config The configuration for each snowflake
 */


var useSnowflakes = function useSnowflakes(canvasRef, amount, config) {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      snowflakes = _useState2[0],
      setSnowflakes = _useState2[1]; // Handle change of amount


  (0, _react.useEffect)(function () {
    setSnowflakes(function (snowflakes) {
      var sizeDifference = amount - snowflakes.length;

      if (sizeDifference > 0) {
        return [].concat(_toConsumableArray(snowflakes), _toConsumableArray(createSnowflakes(canvasRef, sizeDifference, config)));
      }

      if (sizeDifference < 0) {
        return snowflakes.slice(0, amount);
      }

      return snowflakes;
    });
  }, [amount, canvasRef, config]); // Handle change of config

  (0, _react.useEffect)(function () {
    setSnowflakes(function (snowflakes) {
      return snowflakes.map(function (snowflake) {
        snowflake.updateConfig(config);
        return snowflake;
      });
    });
  }, [config]);
  return snowflakes;
};
/**
 * Returns the height and width of a HTML element, uses the `ResizeObserver` api if available to detect changes to the
 * size. Falls back to listening for resize events on the window.
 * @param ref A ref to the HTML element to be measured
 */


exports.useSnowflakes = useSnowflakes;

var useComponentSize = function useComponentSize(ref) {
  var _useState3 = (0, _react.useState)((0, _utils.getSize)(ref.current)),
      _useState4 = _slicedToArray(_useState3, 2),
      size = _useState4[0],
      setSize = _useState4[1];

  var resizeHandler = (0, _react.useCallback)(function () {
    if (ref.current) {
      setSize((0, _utils.getSize)(ref.current));
    }
  }, [ref]);
  (0, _react.useLayoutEffect)(function () {
    var _window = window,
        ResizeObserver = _window.ResizeObserver;
    if (!ref.current) return;
    resizeHandler();

    if (typeof ResizeObserver === 'function') {
      var resizeObserver = new ResizeObserver(resizeHandler);
      resizeObserver.observe(ref.current);
      return function () {
        return resizeObserver.disconnect();
      };
    } else {
      window.addEventListener('resize', resizeHandler);
      return function () {
        return window.removeEventListener('resize', resizeHandler);
      };
    }
  }, [ref, resizeHandler]);
  return size;
};
/**
 * Utility hook that merges any provided styles with the default styles
 * @param overrides The style prop passed into the component
 */


exports.useComponentSize = useComponentSize;

var useSnowfallStyle = function useSnowfallStyle(overrides) {
  var styles = (0, _react.useMemo)(function () {
    return _objectSpread(_objectSpread({}, _config.snowfallBaseStyle), overrides || {});
  }, [overrides]);
  return styles;
};
/**
 * Same as `React.useEffect` but uses a deep comparison on the dependency array. This should only
 * be used when working with non-primitive dependencies.
 *
 * @param effect Effect callback to run
 * @param deps Effect dependencies
 */


exports.useSnowfallStyle = useSnowfallStyle;

function useDeepCompareEffect(effect, deps) {
  var ref = (0, _react.useRef)(deps); // Only update the current dependencies if they are not deep equal

  if (!(0, _reactFastCompare["default"])(deps, ref.current)) {
    ref.current = deps;
  } // eslint-disable-next-line react-hooks/exhaustive-deps


  return (0, _react.useEffect)(effect, ref.current);
}
/**
 * Utility hook to stabilize a reference to a value, the returned value will always match the input value
 * but (unlike an inline object) will maintain [SameValueZero](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * equality until a change is made.
 *
 * @example
 *
 * const obj = useDeepMemo({ foo: 'bar', bar: 'baz' }) // <- inline object creation
 * const prevValue = usePrevious(obj) // <- value from the previous render
 * console.log(obj === prevValue) // <- always logs true until value changes
 */


function useDeepMemo(value) {
  var _useState5 = (0, _react.useState)(value),
      _useState6 = _slicedToArray(_useState5, 2),
      state = _useState6[0],
      setState = _useState6[1];

  useDeepCompareEffect(function () {
    return setState(value);
  }, [value]);
  return state;
}
//# sourceMappingURL=hooks.js.map

/***/ }),

/***/ 57486:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getSize = getSize;
exports.lerp = lerp;
exports.random = random;
exports.randomElement = randomElement;

/**
 * Enhanced random function, selects a random value between a minimum and maximum. If the values provided are both
 * integers then the number returned will be an integer, otherwise the return number will be a decimal.
 * @param min The minimum value
 * @param max The maximum value
 */
function random(min, max) {
  var randomNumber = Math.random() * (max - min + 1) + min;

  if (!Number.isInteger(min) || !Number.isInteger(max)) {
    return randomNumber;
  } else {
    return Math.floor(randomNumber);
  }
}
/**
 * Linear interpolation function to gradually step towards a target value
 * @param start The current value
 * @param end The target value
 * @param normal The rate of change between 0 and 1 (0 = no change, 1 = instant)
 */


function lerp(start, end, normal) {
  return (1 - normal) * start + normal * end;
}
/**
 * Gets the height and width of the provided HTML element
 * @param element The html element to measure
 */


function getSize(element) {
  if (!element) return {
    height: 0,
    width: 0
  };
  return {
    height: element.offsetHeight,
    width: element.offsetWidth
  };
}
/**
 * Selects a random item from an array of inputs.
 *
 * @param items The array of items to choose from
 * @returns A random item selected from the array
 */


function randomElement(items) {
  var index = Math.floor(Math.random() * items.length);
  return items[index];
}
//# sourceMappingURL=utils.js.map

/***/ })

}]);